import { render, staticRenderFns } from "./addMainCashier.vue?vue&type=template&id=311c9edd&scoped=true&"
import script from "./addMainCashier.vue?vue&type=script&lang=js&"
export * from "./addMainCashier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311c9edd",
  null
  
)

export default component.exports